module.exports = __webpack_public_path__ + "static/media/selo-bronze-de-inovacao.1cd698fa.pdf";